import { FC } from "react"

import Dialog from "components/common/dialog/dialog"
import { useTranslation } from "react-i18next"

interface IExportConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

const ExportConfirmDialog: FC<IExportConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onActionButtonClick={onConfirm}
      titleText={t("export.reportAlreadyGeneratingConfirmation")}
    />
  )
}

export default ExportConfirmDialog
